import {
  clubFirebaseConfig,
  clubFirebaseConfigTest,
  clubFirebaseUrlDomainSubstring,
  clubWebsiteUrlDomainSubstring
} from "./clubDetails";

let firebase = require("firebase/app");
require("firebase/functions");
require("firebase/auth");
require("firebase/firestore");

/* this is the main connection to firebase
in order to initialize a new website you need to open a new firebase project and then:
1. past your project firebaseConfig in this file 
2. configure mail, gmail and facebook authentication
3. manually create this empty documents at the database: Debaters\All_debaters, Debate_History\All_Debate_History
*/

/* main site configuration */
const firebaseConfig = clubFirebaseConfig;

/* test site configuration */
const firebaseConfigTest = clubFirebaseConfigTest;

/* determain which firebase project to connect by url */
if (
  window.location.hostname.includes(`${clubWebsiteUrlDomainSubstring}`) ||
  window.location.hostname.includes(`${clubFirebaseUrlDomainSubstring}`)
) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.initializeApp(firebaseConfigTest);
}

export const db = firebase.firestore();
export const auth = firebase.auth();
export function getAuthUid(user) {
  let uid = localStorage.getItem("savedUid");
  if (uid !== null && uid !== undefined && uid !== "null" && uid !== "undefined") {
    return uid;
  }
  let authUser = null;
  if(user === undefined) {
    authUser = auth.currentUser;
  } else {
    authUser = user;
  }
  return authUser.uid;
}
export const functions = firebase.functions();
export const sendEmails = functions.httpsCallable("sendEmails");
export const changePermissions = functions.httpsCallable("changePermissions");
export default firebase;
